// Generat automat din README.md
import React from 'react';
import { TrendingUp, Target, Calendar, BarChart, PieChart, Activity } from 'lucide-react';
import Card from '../../components/Card';
import Badge from '../../components/Badge';

const PreviziuneVanzari = () => {
  const forecastData = [
    { period: 'Aprilie 2024', predicted: '125,000', confidence: '92%', trend: 'up' },
    { period: 'Mai 2024', predicted: '132,000', confidence: '88%', trend: 'up' },
    { period: 'Iunie 2024', predicted: '118,000', confidence: '85%', trend: 'down' },
    { period: 'Iulie 2024', predicted: '145,000', confidence: '79%', trend: 'up' }
  ];

  const keyMetrics = [
    { name: 'Predicție Q2', value: '395,000 RON', change: '+12%', icon: Target },
    { name: 'Acuratețe model', value: '91.5%', change: '+3%', icon: Activity },
    { name: 'Oportunități', value: '47', change: '+8', icon: BarChart },
    { name: 'Rata conversie', value: '23.4%', change: '+1.2%', icon: PieChart }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Previziune Vânzări cu AI</h1>
        <p className="text-gray-600 dark:text-gray-400 mt-2">
          Predicții inteligente bazate pe machine learning și analiza tendințelor
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {keyMetrics.map((metric, index) => (
          <Card key={index} title={metric.name} icon={metric.icon}>
            <div className="text-2xl font-bold text-primary-600">{metric.value}</div>
            <div className={`text-sm ${metric.change.startsWith('+') ? 'text-green-600' : 'text-red-600'}`}>
              {metric.change} vs luna trecută
            </div>
          </Card>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="Grafic Tendință Vânzări" subtitle="Ultimele 12 luni vs Predicții" icon={TrendingUp}>
          <div className="h-64 bg-gray-100 dark:bg-gray-700 rounded-lg flex items-center justify-center">
            <div className="text-center">
              <BarChart className="w-16 h-16 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500">Grafic interactive cu Chart.js</p>
              <p className="text-sm text-gray-400 mt-2">Tendințe istorice + Predicții AI</p>
            </div>
          </div>
        </Card>

        <Card title="Predicții pe Trimestre" subtitle="Următoarele 4 luni" icon={Calendar}>
          <div className="space-y-4">
            {forecastData.map((item, index) => (
              <div key={index} className="p-4 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center space-x-3">
                    <div className={`w-3 h-3 rounded-full ${item.trend === 'up' ? 'bg-green-500' : 'bg-red-500'}`}></div>
                    <span className="font-semibold">{item.period}</span>
                  </div>
                  <Badge variant={item.confidence >= '90%' ? 'success' : item.confidence >= '85%' ? 'warning' : 'info'}>
                    {item.confidence} sigur
                  </Badge>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-bold text-primary-600">{item.predicted} RON</span>
                  <TrendingUp className={`w-5 h-5 ${item.trend === 'up' ? 'text-green-500' : 'text-red-500'}`} />
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Card title="Factorii de Influență">
          <div className="space-y-3">
            <div className="flex items-center justify-between p-3 bg-green-50 dark:bg-green-900/20 rounded">
              <span className="text-sm font-medium text-green-800 dark:text-green-200">Sezonalitate</span>
              <span className="text-sm font-bold text-green-600">+18%</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-blue-50 dark:bg-blue-900/20 rounded">
              <span className="text-sm font-medium text-blue-800 dark:text-blue-200">Marketing Campaigns</span>
              <span className="text-sm font-bold text-blue-600">+12%</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-purple-50 dark:bg-purple-900/20 rounded">
              <span className="text-sm font-medium text-purple-800 dark:text-purple-200">Competiția</span>
              <span className="text-sm font-bold text-purple-600">-5%</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-yellow-50 dark:bg-yellow-900/20 rounded">
              <span className="text-sm font-medium text-yellow-800 dark:text-yellow-200">Tendințe Piață</span>
              <span className="text-sm font-bold text-yellow-600">+8%</span>
            </div>
          </div>
        </Card>

        <Card title="Oportunități Identificate">
          <div className="space-y-3">
            <div className="p-3 border-l-4 border-green-500 bg-green-50 dark:bg-green-900/20">
              <h4 className="font-semibold text-green-800 dark:text-green-200 text-sm">Segment Enterprise</h4>
              <p className="text-green-700 dark:text-green-300 text-xs mt-1">
                Potențial creștere 25% în următoarele 60 zile
              </p>
            </div>
            <div className="p-3 border-l-4 border-blue-500 bg-blue-50 dark:bg-blue-900/20">
              <h4 className="font-semibold text-blue-800 dark:text-blue-200 text-sm">Servicii Cloud</h4>
              <p className="text-blue-700 dark:text-blue-300 text-xs mt-1">
                Cerere crescută cu 40% față de anul trecut
              </p>
            </div>
            <div className="p-3 border-l-4 border-purple-500 bg-purple-50 dark:bg-purple-900/20">
              <h4 className="font-semibold text-purple-800 dark:text-purple-200 text-sm">Cross-selling</h4>
              <p className="text-purple-700 dark:text-purple-300 text-xs mt-1">
                Oportunități suplimentare cu clienții existenți
              </p>
            </div>
          </div>
        </Card>

        <Card title="Acțiuni Recomandate">
          <div className="space-y-3">
            <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium">Intensificare Marketing</span>
                <Badge variant="warning">Urgent</Badge>
              </div>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                Focalizare pe segmentul Enterprise în aprilie
              </p>
            </div>
            <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium">Training Echipă</span>
                <Badge variant="info">Planificat</Badge>
              </div>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                Pregătire pentru creșterea din Q2
              </p>
            </div>
            <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded">
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium">Optimizare Prețuri</span>
                <Badge variant="success">În progres</Badge>
              </div>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                Ajustări bazate pe analiza competiției
              </p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PreviziuneVanzari;